module.exports = __webpack_public_path__ + "img/7.fbdb83e0.png";